export default "__VITE_ASSET__2e1c8e81__"